import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import LanguageCode from '@/locale/language-code';

export interface Keywords {
  language: LanguageCode;
  cancel: string;
  confirm: string;
  submit: string;
  more_info: string;
  price: string;
  save: string;
  save_draft: string;
  back: string;
  premium: string;
  next: string;
  continue_later: string;
  add_a_person: string;
  unfulfilled: string;
  completed: string;
  empty_error_message: string;
  length_error_message: string;
  select_all: string;
  show_more: string;
  show_less: string;
  error_403_title: string;
  error_403_content: string;
  error_404_title: string;
  error_404_content: string;
  error_page_img: string;
  print_transaction_request: string;
  back_to_the_top: string;
  yes: string;
  no: string;
  field_required: string;
  all_field_required: string;
  unsubscribe: string;
  contact_us: string;
  column_title_application_ref: string;
  column_title_service_name: string;
  column_title_status: string;
  add_more_info: string;
  temporary_closed_notification: string;
  consulate_decision_applicant_confirmed: string;
  consulate_decision_cancelled: string;
  consulate_decision_receive: string;
  expired: string;
  consulate_decision_send: string;
}

export default class KeywordsCMSModel implements CMSModel {
  keywords: Keywords[];

  map(obj: any): void {
    this.keywords = _.get(obj, 'translation', []);
  }
}
